import { FilterPlusIcon } from './FilterPlusIcon';

/**
 * author: GreenTurtwig
 * id 3587C73B-5120-4206-9036-2FA87974681B
 * name filter-plus
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-plus.svg
 * tags
 */
export const FunnelPlusIcon = FilterPlusIcon;
export default FunnelPlusIcon